import React from "react";
import InfoBanner from '../InfoBanner'


/**
 * Componente para mostrar la new Brand Equity (Contenido estático)
 *
 * @component
 *
 */

export const BrandEquity = (props) => {
  const [width, setWidth] = React.useState(window.innerWidth);
  const breakpoint = 620;

  React.useEffect(() => {
    const saveWidth = () => {
      setWidth(window.innerWidth);
    };

    /* Inside of a "useEffect" hook add an event listener that updates
        the "width" state variable when the window size changes */
    window.addEventListener("resize", saveWidth);

    /* passing an empty array as the dependencies of the effect will cause this
        effect to only run when the component mounts, and not each time it updates.
        We only want the listener to be added once */
    return () => window.removeEventListener("resize", saveWidth);
  }, []);

  const url = window.location.href;

  return (
    <section id="news-detail" className="text-center">
      <div className="col-md-8 col-md-offset-2 section-title">
        <h2>
          <span className="title">News</span>
        </h2>
      </div>
      <InfoBanner
        section={'Brand Equity'}
        tittle={'El Brand Equity y su relación con el Market Share'}
        readingTime={'Tiempo de lectura 5 minutos'}
        keywords={['Brand Equity', 'Market Share']}
        urlDesktop={'/img/news/BrandEquity/BrandEquity_img1.webp'}
        urlMobile={'/img/news/BrandEquity/BrandEquity_img1_mob.webp'}
      />
      <article className="container-fluid padding-fluid">
        <div className="row">
          <div className="col-md-12 visible-md visible-lg">
            <div className="col-md-1">&nbsp;</div>
          </div>
          <div className="col-md-12 visible-md visible-lg">
            <div className="col-md-1">&nbsp;</div>
          </div>
          <div className="col-md-12 visible-md visible-lg">
            <div className="col-md-1">&nbsp;</div>
          </div>
          <div className="col-md-12">
            <div className="col-md-1">&nbsp;</div>
          </div>
          <div className="col-md-12">
            <div className="col-md-8 col-md-offset-2 text-center">
              <p>
              Cuando se habla de la salud de una marca, no siempre se trata de números fríos y estadísticas. La percepción que los consumidores tienen de tu marca es un activo valioso. En este artículo, exploraremos qué mide un estudio de salud de marca o brand equity, cómo se relaciona con la cuota de mercado y cuestionaremos la pregunta de qué viene primero, ¿el brand equity o las ventas? Desmitificaremos estos conceptos y entenderemos por qué son cruciales para la estrategia de negocio.
                <br></br>
                <br></br>
                <b>Estudio de salud de marca o brand equity</b>
                <br></br>
                <br></br>
                Evalúa la percepción y opinión de las personas sobre tu marca. Aunque no busca una verdad absoluta, arroja valiosos insights sobre las emociones y sensaciones que tu marca evoca en la mente de los clientes. Preguntas como ¿qué nivel de reconocimiento tiene? o ¿qué emociones despierta? encuentran respuesta a través del brand equity.
                <br></br>
                <br></br>
                <b>Su relación con el Market Share</b>
                <br></br>
                <br></br>
                El brand equity y el market share están íntimamente entrelazados. Una percepción positiva y un posicionamiento sólido aumentan la probabilidad de que los consumidores elijan tus productos o servicios en lugar de los de la competencia. Este hecho impulsa las ventas y, consecuentemente, la participación en el mercado.
                <br></br>
                <br></br>
              </p>
            </div>
          </div>
        </div>
      </article>
      <div
        className={width < breakpoint ? "" : "container-fluid padding-fluid"}
      >
        <div className={width < breakpoint ? "" : "row"}>
          <div className={width < breakpoint ? "" : "col-md-12"}>
            <div className={width < breakpoint ? "" : "col-md-8 col-md-offset-2 text-center"}>
              <div className="imgWithText">
                <img
                  style={{ width: "100%" }}
                  className="img-responsive"
                  alt="Brand Equity"
                  src="/img/news/BrandEquity/BrandEquity_img2.webp"
                ></img>
                <h2 className="img3Text">La percepción de la marca y la preferencia del consumidor a la hora de comprar prevalecen.</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <article className="container-fluid padding-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="col-md-8 col-md-offset-2 text-center">
              <p>
                Esta es una pregunta común en el mundo del marketing. La realidad es que el Brand Equity es el precursor de las ventas. Cuando tu marca es sólida y bien percibida, la gente confía en los servicios y es más probable que los compre. Las ventas son una consecuencia de la percepción positiva de la marca. Entonces, antes de enfocarse exclusivamente en las cifras, hay que asegurarse de que la marca tenga un buen posicionamiento.
                <br></br>
                <br></br>
                <b>Premisas Básicas: </b>
                <br></br>
                <br></br>
                1. Cada indicador mide cosas distintas: Es importante recordar que el Brand Equity y las ventas son dos cosas diferentes. Mientras que el primero se centra en la percepción, el segundo se trata de resultados concretos. Ambos son importantes, pero miden aspectos distintos.
                <br></br>
                <br></br>
                2. El margen de error no es importante: No es necesario obsesionarse con números precisos. Los estudios de marca a menudo se basan en percepciones subjetivas, por lo que no hay una verdad absoluta. Lo que importa es la tendencia y las áreas de mejora que identifiques.
                <br></br>
                <br></br>
                3. Actitud Abierta: No asumir que ya conoces todo sobre tu marca. Estudiar la opinión de los demás puede proporcionar información valiosa y reveladora.
                <br></br>
                <br></br>
                <b>El rol de la marca </b>
                <br></br>
                <br></br>
                El objetivo fundamental de tener una marca sólida y saludable es poder seguir vendiendo más en el futuro. Una marca bien percibida genera confianza y lealtad entre clientes, lo que se traduce en un flujo constante de ventas.
                <br></br>
                <br></br>
                <br className="visible-md visible-lg"></br>
              </p>
            </div>
          </div>
        </div>
      </article>
      <div
        className={width < breakpoint ? "" : "container-fluid padding-fluid"}
      >
        <div className={width < breakpoint ? "" : "row"}>
          <div className={width < breakpoint ? "" : "col-md-12"}>
            <div className={width < breakpoint ? "" : "col-md-8 col-md-offset-2 text-center"}>
              <div className="imgWithText">
                <img
                  style={{ width: "100%" }}
                  className="img-responsive"
                  alt="Brand Equity"
                  src="/img/news/BrandEquity/BrandEquity_img3.webp"
                ></img>
                <h2 className="img3Text">La confianza y apego que una marca estable y bien valorada genera entre los consumidores, asegura un flujo ininterrumpido de ventas.</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <article className="container-fluid padding-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="col-md-8 col-md-offset-2 text-center">
              <p>
                <b>Brand Funnel y Brand Funnel Strength</b>
                <br></br>
                <br></br>
                Estos modelos ayudan a las marcas a crecer y obtener fidelidad. Cuantos más clientes tengas en la base del funnel, mejores serán los resultados de marca y, por ende, las ventas. La fuerza del funnel se calcula ponderando la salud de tu marca en diferentes segmentos de la población.
                <br></br>
                <br></br>
                En conclusión, entender el Brand Equity es esencial para el éxito empresarial. No se trata solo de números, sino de cómo las personas perciben tu marca. Una marca fuerte puede impulsar tus ventas y aumentar el market share. También la investigación y el análisis son clave. Recuerda que contar con una consultora de medios que te asesore en objetivos medibles es fundamental. Conoce a tu audiencia, da a conocer a tu marca y observa cómo crece tu negocio.
                <br></br>
                <br></br>
              </p>
            </div>
            <div className="col-md-1 text-left"></div>
            <div
              className="col-md-3 text-left"
              style={{ display: width < breakpoint ? "block" : "none" }}
            >
              <p className="titleShare">COMPARTE</p>
              <div style={{ paddingBottom: "7px" }}>
                <a
                  className="share"
                  href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Facebook
                </a>
              </div>
              <div style={{ paddingBottom: "7px" }}>
                <a
                  className="share"
                  href={`https://twitter.com/intent/tweet?url=${url}&text=Brand Equity`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Twitter
                </a>
              </div>
              <div style={{ paddingBottom: "7px" }}>
                <a
                  className="share"
                  href={`https://www.linkedin.com/sharing/share-offsite/?url=${url}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  LinkedIn
                </a>
              </div>
              <div style={{ paddingBottom: "7px" }}>
                <a
                  className="share"
                  href={`mailto:?subject=Quiero compartir contigo esta noticia&body=Mira esta noticia ${url}`}
                >
                  Email
                </a>
              </div>
            </div>
          </div>
        </div>
      </article>
    </section>
  );
};
